export const ComponentPropsOption = {
    dark: { type: Boolean },
};

export type ComponentProps = ExtractPropTypes<typeof ComponentPropsOption>;
